export function initScrolltopbutton(scrolltopButtons = document.querySelectorAll(".js-scrollTop")) {
    if (!scrolltopButtons.length) return;

    let ticking = false;

    function updateButtonVisibility() {
        const isScrolled = window.scrollY > 100;

        for (let button of scrolltopButtons) {
            button.classList.toggle('sticky', isScrolled);
        }

        ticking = false;
    }

    function onScroll() {
        if (!ticking) {
            requestAnimationFrame(updateButtonVisibility);
            ticking = true;
        }
    }

    function scrollToTop() {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    }

    updateButtonVisibility();

    window.addEventListener('scroll', onScroll, { passive: true });

    for (let button of scrolltopButtons) {
        button.addEventListener('click', scrollToTop);
    }
}